export default "__VITE_ASSET__CswTpJnm__"